<template>
  <custom-dialog width="1080px" :append-to-body="true" :title="model.title" :visible="visible" v-on="$listeners" class="step-manage-pre">
    <div class="dialog-body">
      <el-form :model="form" :inline="true" :rules="rules" size="mini" ref="form">
        <el-row>
          <el-col :span="6">
            <el-form-item :label="$t('crm_managePreviewDialog.chan_pin_xing_hao')">
              {{ model.data.row.productCode }}
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('crm_managePreviewDialog.zu_jin_yue')">
              <span v-if="isDiscounted" class="name discount-rent">￥{{ finalRent.toFixed(2) }} / <del>￥{{ model.data.row.unitPrice }}</del></span>
              <span v-else class="name">￥{{ model.data.row.unitPrice }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('crm_managePreviewDialog.zhi_fu_zhou_qi')">
              <span class="name">
                {{ paymentPeriod[model.data.row.paymentPeriod] }}
              </span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('crm_managePreviewDialog.shfjfy')">
              <span class="name">￥{{ model.data.row.additionalFee }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item :label="$t('crm_managePreviewDialog.swfdjey')">
              <span class="name">￥{{ getNumber(model.data.row.discountPrice) }}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="7">
            <el-form-item :label="$t('crm_managePreviewDialog.jhzlys')" prop="month">
              <el-input type="number" :min="0" size="small" v-model="form.month" style="width: 250px"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item :label="$t('crm_managePreviewDialog.ji_hua_qi_zu_ri_qi')" prop="startDate">
              <custom-date-picker size="small" v-model="form.startDate" type="date" :picker-options="{ firstDayOfWeek: 1 }" style="width: 250px" :placeholder="$t('Common.com_please_select')"></custom-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="7">
            <el-form-item :label="$t('crm_managePreviewDialog.zhi_fu_jie_dian')" prop="paymentNode">
              <custom-select :dataFilter="dataFilter" :disabled="`${model.data.row.paymentNode}` !== '0'" v-model="form.paymentNode" code="payment_node" width="250px"></custom-select>
            </el-form-item>
          </el-col>
          <el-col :span="3">
            <el-form-item label="" style="padding-top: 28px">
              <el-button size="small" type="primary" @click="confirm">{{ $t('crm_managePreviewDialog.sczd') }}</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <ul>
        <li v-for="(item, index) in sharingList" :key="index">
          <h1 class="type">{{ item.sharingClass }}</h1>
          <div class="info">
            <el-row>
              <el-col :span="8">
                <span>
                  {{ $t('crm_managePreviewDialog.jfdbmyysje') }}：￥{{ getAgentCoProfit(item) }}&emsp;(￥{{
                    (getAgentCoProfit(item) * (Number.parseInt(model.data.row.paymentPeriod, 10) || Number.parseInt(form.month, 10) || 1)) | formatNumberCalc
                  }}/{{ $t('crm_managePreviewDialog.qi') }})
                </span>
              </el-col>
              <el-col :span="8">
                <span>
                  {{ $t('crm_managePreviewDialog.shmyysje') }}：￥{{ item.afterServiceProfit }}&emsp;(￥{{
                    (item.afterServiceProfit * (Number.parseInt(model.data.row.paymentPeriod, 10) || Number.parseInt(form.month, 10) || 1)) | formatNumberCalc
                  }}/{{ $t('crm_managePreviewDialog.qi') }})
                </span>
              </el-col>
              <el-col :span="8">
                <span>
                  {{ $t('crm_managePreviewDialog.zbmyysje') }}：￥{{ item.hqProfit }}&emsp;(￥{{
                    (item.hqProfit * (Number.parseInt(model.data.row.paymentPeriod, 10) || Number.parseInt(form.month, 10) || 1)) | formatNumberCalc
                  }}/{{ $t('crm_managePreviewDialog.qi') }})
                </span>
              </el-col>
            </el-row>
          </div>
          <el-table :size="allTableSize" :data="item.children">
            <el-table-column :label="$t('crm_managePreviewDialog.qi_shu')" type="index" width="44"></el-table-column>
            <el-table-column prop="startDate" :label="$t('crm_managePreviewDialog.zdkssj')"></el-table-column>
            <el-table-column prop="endDate" :label="$t('crm_managePreviewDialog.zdjssj')"></el-table-column>
            <el-table-column prop="payDate" :label="$t('crm_managePreviewDialog.zhi_fu_ri_qi')"></el-table-column>
            <el-table-column prop="pay" :label="$t('crm_managePreviewDialog.zu_lin_fang_ying_fu')">
              <template slot-scope="scope">
                {{ (scope.row.lenData * (finalRent + getNumber(model.data.row.additionalFee))) | formatNumberCalc }}
              </template>
            </el-table-column>
            <el-table-column prop="hqProfit" :label="$t('crm_managePreviewDialog.zong_bu_ying_shou')">
              <template slot-scope="scope">
                {{ (scope.row.lenData * item.hqProfit) | formatNumberCalc }}
              </template>
            </el-table-column>
            <el-table-column prop="afterServiceProfit" :label="$t('crm_managePreviewDialog.shgsfc')">
              <template slot-scope="scope">
                {{ (scope.row.lenData * item.afterServiceProfit + scope.row.lenData * getNumber(model.data.row.additionalFee)) | formatNumberCalc }}
              </template>
            </el-table-column>
            <el-table-column prop="agentCoProfit" :label="$t('crm_managePreviewDialog.jfdbfc')">
              <template slot-scope="scope">
                {{ (scope.row.lenData * getAgentCoProfit(item)) | formatNumberCalc }}
              </template>
            </el-table-column>
          </el-table>
        </li>
      </ul>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button size="small" type="primary" @click="visible = false">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
import moment from 'moment';
import dialogMixins from '@/mixins/dialog_mixins.js';
import customDatePicker from '../../../components/customDatePicker.vue';

export default {
  components: { customDatePicker },
  mixins: [dialogMixins],
  data() {
    return {
      // translate: { i18n },
      paymentPeriod: {},
      sharingList: [],
      tableList: [],
      form: {
        month: '',
        startDate: '',
        paymentNode: '',
      },
      itemForm: {
        startDate: '',
        endDate: '',
        payDate: '',
        pay: '',
        hqProfit: '',
        afterServiceProfit: '',
        agentCoProfit: '',
      },
    };
  },
  computed: {
    finalRent() {
      return this.getNumber(this.model.data.row.unitPrice) + this.getNumber(this.model.data.row.discountPrice);
    },
    isDiscounted() {
      return this.getNumber(this.model.data.row.discountPrice) !== 0;
    },
    rules() {
      return {
        month: { required: true, message: this.$t('crm_managePreviewDialog.qtxzlys') },
        startDate: { required: true, message: this.$t('crm_managePreviewDialog.qxzjhqzrq') },
        paymentNode: { required: true, message: this.$t('crm_managePreviewDialog.qxzzfjd') },
      };
    },
  },
  mounted() {
    if (this.model.data.row.paymentNode !== 0) {
      this.form.paymentNode = `${this.model.data.row.paymentNode}`;
    }
    if (this.model.data.month) {
      this.form.month = this.model.data.month;
    }
    this.getDictionary('crm_payment_period', (data) => {
      this.paymentPeriod = this.$transformDicValue(data.crm_payment_period);
    });
    this.sharingList = this.model.data.row.sharingList;
  },
  methods: {
    getNumber(value) {
      const number = Number(value);
      return Number.isNaN(number) ? 0 : number;
    },
    // 商务浮动金额从甲方代理分成中扣减或增加。
    getAgentCoProfit(item) {
      return this.getNumber(item.agentCoProfit) + this.getNumber(this.model.data.row.discountPrice);
    },
    // 确认保存
    confirm: function () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return;
        }
        this.computedPay();
      });
    },

    // 支付节点(过滤)
    dataFilter: function (list) {
      return list.filter((t) => t.code !== 'all');
    },
    // 获取付款期数
    getPeriods: function () {
      const row = this.model.data.row;
      const paymentPeriod = Number.parseInt(row.paymentPeriod, 10); // 付款周期，0为全款
      const month = Number.parseInt(row.paymentPeriod, 10); // 租赁月数
      const remainder = paymentPeriod ? month % paymentPeriod : 0; // 余数
      let periods = 1; // 期数
      if (remainder) {
        periods = this.form.month / paymentPeriod + 1;
      } else if (paymentPeriod) {
        periods = this.form.month / paymentPeriod;
      }
      return periods;
    },
    // 每期时间计算
    setPeriodsDate: function (periods, paymentPeriod, form) {
      const arr = [];
      const start = this.$momentElLocal(form.startDate); // 启租时间
      const paymentNode = Number.parseInt(form.paymentNode, 10); // 支付节点
      const month = Number.parseInt(form.month, 10); // 租赁月数

      for (let index = 0; index < periods; index++) {
        const lastPeriod = paymentPeriod * (index + 1) > month ? month : paymentPeriod * (index + 1); // 最后一期可能不足周期
        const startDate = moment(start)
          .add(paymentPeriod * index, 'months')
          .format(this.$getElFormat('YYYY-MM-DD', false));
        const endDate = moment(start)
          .add(lastPeriod || month, 'months')
          .format(this.$getElFormat('YYYY-MM-DD', false));
        arr.push({
          startDate: startDate,
          endDate: endDate,
          payDate: paymentNode === 2 ? endDate : startDate,
          lenData: paymentPeriod * (index + 1) > month ? month - paymentPeriod * index : paymentPeriod || month, // 期数时长（月）
        });
      }
      return arr;
    },
    // 保存新增
    computedPay: function () {
      const periods = this.getPeriods(); // 付款期数
      const paymentPeriod = Number.parseInt(this.model.data.row.paymentPeriod, 10); // 付款周期，0为全款
      const sharingList = JSON.parse(JSON.stringify(this.sharingList)); // 方案AB..
      sharingList.forEach((ele) => {
        const list = this.setPeriodsDate(periods, paymentPeriod, this.form);
        this.$set(ele, 'children', list);
      });
      this.sharingList = sharingList;
    },
  },
};
</script>

<style lang="scss">
.step-manage-pre {
  .name {
    line-height: 24px;
  }
  .discount-rent {
    color: #f5222d;
    font-weight: bold;
  }
  .info {
    padding-top: 6px;
    padding-bottom: 16px;
    span {
      font-size: 12px;
    }
  }
  .type {
    font-weight: bold;
    font-size: 32px;
    color: #0d9ae8;
    padding-left: 4px;
  }
}
</style>
